export let getAddIns_Button = "AoKMEe";
export default {getAddIns_Button};